import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
    indicatorLabel: {
        color: theme.palette.grey[600],
    },
}));
